import { useRef } from "react";

const useDeepCompareMemo = (value: any) => {
  const previousRef = useRef(value);
  const previousValue = previousRef.current;

  // Chỉ cập nhật giá trị nếu nó thực sự thay đổi
  const isSame = isEqual(previousValue, value);
  if (!isSame) {
    previousRef.current = value;
  }

  return previousRef.current;
};

export default useDeepCompareMemo;

const isEqual = (a: any, b: any): boolean => {
  return JSON.stringify(a) === JSON.stringify(b);
};
